<template lang="pug">
system-tabs(section="/system/tickets")
    //- Nothing is saved here, so the only button is the way back to the list —
    //- as a circle in the tab bar and labelled below, like every other page.
    //- The mutation-free navigation lives in TicketGanttChart — see dismiss()
    //- there for why.
    template(slot="tabbar-buttons")
        el-button(
            circle
            icon="el-icon-fa-times fas"
            @click="callGantt('dismiss')"
        )
    //- contains-table: a panel card is flush (body padding 0) and its content
    //- carries the spacing, the way every paginated list in the admin is built.
    el-card.contains-table(shadow="always")
        ticket-gantt-chart(ref="gantt" scope="system")
    .buttons-flex
        .form-buttons
        .form-buttons
            el-button(round icon="el-icon-fa-times fas" @click="callGantt('dismiss')") {{ $t('Dismiss') }}
</template>

<i18n>
{
    "de": {
        "Dismiss": "Verwerfen"
    }
}
</i18n>

<script>
import SystemTabs from '@/views/system/Partials/Tabs';
import TicketGanttChart from '@/extensions/tickets/views/TicketGanttChart';

// Pure chrome: the system tab bar and its Dismiss button. The navigation it
// triggers lives on TicketGanttChart itself and is reached through
// callGantt() — one copy, shared with the CMS wrapper.
export default {
    name: 'SystemTicketGantt',
    components: { SystemTabs, TicketGanttChart },
    methods: {
        callGantt(method, ...args) {
            const gantt = this.$refs.gantt;
            if (gantt) gantt[method](...args);
        },
    },
};
</script>
